import { ValueProvider } from '@angular/core';
import { VimCoreBaseConfig } from './const';

export function provideVimCoreBaseConfig(config: Partial<VimCoreBaseConfig>): ValueProvider {
  return { provide: VimCoreBaseConfig, useValue: config };
}
